import defaultProfileImg from '../../../assets/images/default_profile_img.png';
import { RiDeleteBin5Line } from "react-icons/ri";
import { Privileges } from '../../../util/PrivilegeConstants';
import { UserStatus } from '../../../util/UserStatus';
import { MdOutlineEdit } from 'react-icons/md';

const RowDataItem = ({ userData, privileges, deleteMember, handleOpenEditPopup }) => {



    return (
        <div className='row_data_item_container'>
            <div className='row_data_item_part1'>
                <img src={defaultProfileImg} alt="" />
                <div className='row_data_item_part1_details'>
                    <h3>{userData?.userFirstName + " " + userData?.userLastName}</h3>
                    <p>{userData?.userEmail}</p>
                </div>
            </div>
            <div className='row_data_item_part2'>
                {userData?.userStatus === UserStatus.ACTIVE &&
                    <p className='row_data_item_part2_name'>Active</p>}
                {userData?.userStatus === UserStatus.INACTIVE &&
                    <p className='row_data_item_part2_name_in_active'>In Active</p>}
                {userData?.userStatus === UserStatus.PENDING &&
                    <p className='row_data_item_part2_name_pending'>Pending</p>}
            </div>
            <div className='row_data_item_part3'>
                {
                    userData?.roles?.map((data, index) =>
                        <p key={index}>{data}</p>
                    )
                }
            </div>
            <div className='row_data_item_part4'>
             {(privileges?.MANAGE_INVITE_STAFF?.includes(Privileges.MODIFY)) &&
                <MdOutlineEdit onClick={() => handleOpenEditPopup(userData.userId,userData?.roles?.map(item=>item.toUpperCase()))} className='row_data_item_part4_edit_icon' />
             }  
              {(privileges?.MANAGE_INVITE_STAFF?.includes(Privileges.DELETE)) &&
                    <RiDeleteBin5Line onClick={() => deleteMember(userData?.userId)} className='row_data_item_part4_icon' />}
            </div>
        </div>
    )
}

export default RowDataItem